<template>
  <!-- v-if="$store.state.onePageHidden" -->
  <div class="admin-home">
    <page-title :title="`待处理内容`" class="wait-for-handle">
      <div slot="title" class="subtitle">
        <i class="el-icon el-icon-question"></i>
        显示待审核、待处理数量，点击可跳转至相应的列表页面（默认筛选状态为待审核、待处理）
      </div>
      <div class="body">
        <wait-panel
          type="szbqdj"
          :data="{
            total: registrationData.total,
            increase: registrationData.today,
          }"
        ></wait-panel>
        <wait-panel
          type="works"
          :data="{
            total: worksCheckingData.total,
            increase: worksCheckingData.today,
          }"
        ></wait-panel>
        <wait-panel
          type="withdraw"
          :data="{
            total: withdrawingData.total,
            increase: withdrawingData.today,
          }"
        ></wait-panel>
        <wait-panel
          type="users"
          :data="{ total: userCertifyNumber, increase: 0 }"
        ></wait-panel>
        <wait-panel
          type="contract"
          :data="{
            total: signContractData.total,
            increase: signContractData.today,
          }"
        ></wait-panel>
      </div>
      <div class="body" style="padding-top: 20px">
        <wait-panel
          type="bqdj"
          :data="{
            total: topPtbqData.total,
            increase: topPtbqData.increasedToday,
          }"
        ></wait-panel>
        <wait-panel
          type="fpdcl"
          :data="{
            total: topFpdclData.total,
            increase: topFpdclData.increasedToday,
          }"
        ></wait-panel>
        <wait-panel
          type="bqwqdcl"
          :data="{
            total: topBqwqdclData.total,
            increase: topBqwqdclData.increasedToday,
          }"
        ></wait-panel>
      </div>
    </page-title>
    <ul class="wait-for-handle-addon">
      <li
        class="handle-addon-item"
        @click="$router.push({ path: '/listWorks', query: { status: '5' } })"
      >
        <div class="left-icon">
          <img src="@/assets/images/homeIcon/icon-data.png" />
        </div>
        <div class="right-body">
          <h4>上架作品数</h4>
          <div>
            <span>{{ saleWorks.total }}</span>
            <span>今日&nbsp;+{{ saleWorks.today }}</span>
          </div>
        </div>
      </li>
      <li
        class="handle-addon-item"
        @click="$router.push({ path: '/KBManage', query: { status: '5' } })"
      >
        <div class="left-icon">
          <img src="@/assets/images/homeIcon/icon-data-split.png" />
        </div>
        <div class="right-body">
          <h4>上架资源数</h4>
          <div>
            <span>{{ saleResources.total }}</span>
            <span>今日&nbsp;+{{ saleResources.today }}</span>
          </div>
        </div>
      </li>
      <li
        class="handle-addon-item"
        @click="
          $router.push({ path: '/contractManagement', query: { status: '2' } })
        "
      >
        <div class="left-icon">
          <img src="@/assets/images/homeIcon/icon-data.png" />
        </div>
        <div class="right-body">
          <h4>签约数</h4>
          <div>
            <span>{{ passSts.total }}</span>
            <span>今日&nbsp;+{{ passSts.today }}</span>
          </div>
        </div>
      </li>
    </ul>
    <div class="flex-row">
      <page-title class="mall-data flex-col" title="版权登记数据">
        <div slot="title" class="mall-data-subtitle">
          <div class="mall-sales-legend">
            <span>普通版权登记</span>
            <span>数字版权登记</span>
          </div>
          <!-- <div class="mall-sales-legend">
            <span style="">成交商品数</span>
            <span>成交订单金额</span>
          </div> -->
          <!-- <el-date-picker
            v-model="mallSellData"
            type="daterange"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            format="yyyy/MM/dd"
            value-format="yyyy-MM-dd"
            size="mini"
            :clearable="false"
            :editable="false"
          >
          </el-date-picker> -->
        </div>
        <div id="echarts" ref="mallDataEcharts1"></div>
      </page-title>
      <page-title class="mall-data flex-col" title="版权保护数据">
        <div slot="title" class="mall-data-subtitle">
          <div class="mall-sales-legend">
            <span class="qwjc">全网监测</span>
            <span class="bqwq">版权维权</span>
            <span class="spqz">视频取证</span>
            <span class="wyqz">网页取证</span>
          </div>
          <!-- <div class="mall-sales-legend">
            <span style="">成交商品数</span>
            <span>成交订单金额</span>
          </div> -->
          <!-- <el-date-picker
            v-model="mallSellData"
            type="daterange"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            format="yyyy/MM/dd"
            value-format="yyyy-MM-dd"
            size="mini"
            :clearable="false"
            :editable="false"
          >
          </el-date-picker> -->
        </div>
        <div id="echarts" ref="mallDataEcharts2"></div>
      </page-title>
      </page-title>
      <page-title class="mall-data flex-col" title="交易数据（单位：元）">
        <div slot="title" class="mall-data-subtitle">
          <div class="mall-sales-legend">
            <span class="spqz">作品</span>
            <span class="wyqz">资源</span>
          </div>
        </div>
        <div id="echarts" ref="mallDataEcharts3"></div>
      </page-title>
    </div>
    <!-- <div class="flex-row"> -->
    <!-- <page-title class="mall-data flex-col" title="商城销售数据">
        <div slot="title" class="mall-data-subtitle">
          <div class="mall-sales-legend">
            <span>成交商品数</span>
            <span>成交订单金额</span>
          </div>
        </div>
        <div id="echarts" ref="mallDataEcharts"></div>
      </page-title> -->
    <!-- <page-title class="shop-sales-data flex-col" title="店铺销售排行榜">
        <div class="shop-sales-data__body">
          <div class="selector">
            <span>排行类型：</span>
            <el-select size="small" style="width:100px;" v-model="shopSales.days" @change="rankTypeChange">
              <el-option :value="1" label="日榜"></el-option>
              <el-option :value="7" label="周榜"></el-option>
              <el-option :value="30" label="月榜"></el-option>
            </el-select>
          </div>
          <div class="selector">
            <span>排行数量：</span>
            <el-select size="small" style="width:100px;" v-model="shopSales.top" @change="rankTypeChange">
              <el-option :value="5" label="5"></el-option>
              <el-option :value="10" label="10"></el-option>
              <el-option :value="15" label="15"></el-option>
            </el-select>
          </div>
          <el-table
            :data="topShopData"
            style="width: 100%;"
            height="289"
            :header-cell-style="{ backgroundColor: `#f7f7f7`, fontWeight: 500 }"
          >
            <el-table-column width="70" label="排名" type="index" align="center"></el-table-column>
            <el-table-column width="auto" prop="1" label="店铺名称"></el-table-column>
            <el-table-column width="125" prop="0" label="销售商品数量"></el-table-column>
            <el-table-column width="155" prop="2" label="销售总金额"></el-table-column>
          </el-table>
        </div>
      </page-title> -->
    <!-- </div> -->
    <div class="flex-row">
      <page-title class="goods-category-propor  flex-col" title="版权库作品分类">
        <div id="echarts" ref="goodsCategoryEchart"></div>
      </page-title>
      <!-- <page-title title="最近成交单" class="recent flex-col">
        <div class="recent__body">
          <el-table :data="orderData" style="width: 100%" :header-cell-style="{ backgroundColor: `#f7f7f7`, fontWeight: 500 }">
            <el-table-column width="415" label="成交单记录">
              <template slot-scope="{ row }">
                <div class="table-col">
                  <div class="buyer-label">
                    <i class="el-icon-user-solid"></i>
                    <span :title="row.userInfo ? row.userInfo.nickname : ''">
                      {{ row.userInfo ? row.userInfo.nickname : '用户' }}
                    </span>
                  </div>
                  <span class="text-label">购买了</span>
                  <div class="seller-label">
                    <i class="el-icon-s-shop"></i>
                    <span :title="row.store ? row.store.name : ''">{{ row.store ? row.store.name : '店铺' }}</span>
                  </div>
                  <span class="text-label">的{{ row.orderItems ? row.orderItems.length : 1 }}件商品</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip width="165" prop="orderNo" label="订单编号"></el-table-column>
            <el-table-column show-overflow-tooltip prop="createdDate" label="时间" width="auto"></el-table-column>
          </el-table>
        </div>
      </page-title> -->
      <page-title title="登记来源" class="user-type flex-col">
        <div id="echarts" ref="userTypeEchart"></div>
      </page-title>
      <page-title title="版权登记作品分类" class="shop-type flex-col">
        <div id="echarts" ref="shopTypeEchart"></div>
      </page-title>
    </div>
  </div>
</template>
<script>
import PageTitle from "@/components/pageTitle.vue";
import WaitPanel from "./components/waitPanel.vue";
import { PieChart, BarChart } from "echarts/charts";
import { CanvasRenderer } from "echarts/renderers";
import { orderGet } from "@/api/order";
import {
  homeGet,
  shoppingGet,
  shopGet,
  commodityGet,
  userGet,
  storeGet,
  feedbackGet,
  complainGoodsGet,
  complainStoreGet,
  commodityClassifyGet,
  topShop,
  topPtbq,
  topFpdcl,
  topBqwqdcl,
  withdrawing,
  bqdjMap,
  bqbhMap,
  worksChecking,
  workCategoryGet,
  registerSourceGet,
} from "@/api/home";
import { getUserList, getWithdrawList } from "@/api/req";
import { color } from "@/utils/color";

/**
 * echarts v5.*按需引入
 */
import * as echarts from "echarts/core";
import {
  DatasetComponent,
  GridComponent,
  TooltipComponent,
  LegendComponent,
} from "echarts/components";
echarts.use([
  TooltipComponent,
  LegendComponent,
  PieChart,
  CanvasRenderer,
  BarChart,
  DatasetComponent,
  GridComponent,
]);
// debounce防抖函数
const debounce = (fn, delay) => {
  let timer = null;
  return function (...args) {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      fn.apply(this, args);
    }, delay);
  };
};
export default {
  name: "home",
  components: {
    PageTitle,
    WaitPanel,
  },
  data() {
    return {
      color,
      // mallData: `${new Date().toLocaleDateString().replace(/\//g, '-')},${new Date().toLocaleDateString().replace(/\//g, '-')}`,
      orderData: [], //最近成交
      mallSalesOptionsData: [], //商城销售数据
      commodityData: {}, //商品待审核
      registrationData: {}, //数字版权登记待审核
      signContractData: {}, //签约待审核
      shopGetData: {}, //店铺待审核
      userTypeData: {}, //登记来源
      shopTypeData: [], //版权登记作品分类
      feedback: {}, //投诉店铺待处理
      saleWorks: {}, // 上架作品
      saleResources: {}, // 上架资源
      passSts: {}, // 签约数
      complainGoods: {}, //投诉商品待处理
      complainStore: {}, //意见反馈待处理
      commodityClassify: {}, //商品分类比例
      topShopData: [], // 商城店铺销售排行
      userCertifyNumber: 0, // 用户待审核
      withdrawingData: {}, // 提现待审核
      worksCheckingData: {}, // 作品待审核
      topPtbqData: {}, //普通版权
      topFpdclData: {}, // 发票
      topBqwqdclData: {}, // 版权维权待处理
      bqdjMapData: [],
      bqbhMapData: [],
      jyMapData: [],
      shopSales: {
        days: 30,
        top: 5,
      },
    };
  },
  computed: {
    // mallSellData: {
    //   get() {
    //     return this.mallData.split(',');
    //   },
    //   set(val) {
    //     this.mallData = val.join(',');
    //   }
    // },
    mallDataEcharts1() {
      return {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: this.bqdjMapData.map((item) => item.date),
            axisLabel: {
              interval: 0,
              rotate: 18,
              align: "center",
              margin: 24,
              fontSize: 12,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
          },
        ],
        series: [
          {
            name: "普通版权登记",
            type: "bar",
            barWidth: 20,
            stack: "Search Engine",
            emphasis: {
              focus: "series",
            },
            backgroundStyle: {
              color: "#f7faff",
            },
            itemStyle: {
              color: "#005bff",
            },
            data: this.bqdjMapData.map((item) => item.normal),
          },
          {
            name: "数字版权登记",
            type: "bar",
            barWidth: 20,
            stack: "Search Engine",
            emphasis: {
              focus: "series",
            },
            backgroundStyle: {
              color: "#f7fdfb",
            },
            itemStyle: {
              color: "#00bd83",
            },
            data: this.bqdjMapData.map((item) => item.digital),
          },
        ],
      };
    },
    mallDataEcharts2() {
      return {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: this.bqbhMapData.map((item) => item.date),
            axisLabel: {
              interval: 0,
              rotate: 18,
              align: "center",
              margin: 24,
              fontSize: 12,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
          },
        ],
        series: [
          {
            name: "全网监测",
            type: "bar",
            barWidth: 20,
            stack: "Search Engine",
            emphasis: {
              focus: "series",
            },
            backgroundStyle: {
              color: "#f7faff",
            },
            itemStyle: {
              color: "#00bd83",
            },
            data: this.bqbhMapData.map((item) => item.infringementDetection),
          },
          {
            name: "网页取证",
            type: "bar",
            barWidth: 20,
            stack: "Search Engine",
            emphasis: {
              focus: "series",
            },
            backgroundStyle: {
              color: "#f7fdfb",
            },
            itemStyle: {
              color: "#ff6653",
            },
            data: this.bqbhMapData.map((item) => item.imageEvidence),
          },
          {
            name: "视频取证",
            type: "bar",
            barWidth: 20,
            stack: "Search Engine",
            emphasis: {
              focus: "series",
            },
            backgroundStyle: {
              color: "#f7faff",
            },
            itemStyle: {
              color: "#00aaff",
            },
            data: this.bqbhMapData.map((item) => item.videoEvidence),
          },
          {
            name: "版权维权",
            type: "bar",
            barWidth: 20,
            stack: "Search Engine",
            emphasis: {
              focus: "series",
            },
            backgroundStyle: {
              color: "#f7faff",
            },
            itemStyle: {
              color: "#f5b160",
            },
            data: this.bqbhMapData.map((item) => item.protectRight),
          },
        ],
      };
    },
    mallDataEcharts3() {
      return {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: this.jyMapData.map((item) => item.date),
            axisLabel: {
              interval: 0,
              rotate: 18,
              align: "center",
              margin: 24,
              fontSize: 12,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
          },
        ],
        series: [
          {
            name: "作品",
            type: "bar",
            barWidth: 20,
            stack: "Search Engine",
            emphasis: {
              focus: "series",
            },
            backgroundStyle: {
              color: "#f7fdfb",
            },
            itemStyle: {
              color: "#2ab4fc",
            },
            data: this.jyMapData.map((item) => item.digital),
          },
          {
            name: "资源",
            type: "bar",
            barWidth: 20,
            stack: "Search Engine",
            emphasis: {
              focus: "series",
            },
            backgroundStyle: {
              color: "#f7fdfb",
            },
            itemStyle: {
              color: "#f68679",
            },
            data: this.jyMapData.map((item) => item.normal),
          },
        ],
      };
    },
    mallSalesOptions() {
      return {
        legend: {
          show: false,
        },
        grid: {
          top: 20,
          right: 10,
          left: 50,
          botton: 0,
        },
        tooltip: {
          formatter: function (para) {
            if (para.seriesName === "amount")
              return `成交订单金额: ${para.value.amount}`;
            else if (para.seriesName === "count")
              return `成交商品数: ${para.value.count}`;
            else return "";
          },
        },
        dataset: {
          dimensions: ["date", "count", "amount"],
          source: this.mallSalesOptionsData.reverse(),
        },
        xAxis: {
          type: "category",
          axisTick: {
            alignWithLabel: true,
            interval: 0,
          },
          axisLabel: {
            interval: 0,
            rotate: 18,
            align: "center",
            margin: 24,
            fontSize: 12,
          },
        },
        yAxis: {
          axisLine: {
            show: false,
          },
          splitLine: {
            lineStyle: {
              type: "dashed",
            },
          },
          axisTick: {
            show: false,
          },
        },
        series: [
          {
            type: "bar",
            showBackground: true,
            backgroundStyle: {
              color: "#f7faff",
              borderRadius: [12, 12, 0, 0],
            },
            itemStyle: {
              borderRadius: [12, 12, 0, 0],
              color: "#005bff",
            },
            barWidth: 12,
            barGap: "100%",
          },
          {
            type: "bar",
            showBackground: true,
            backgroundStyle: {
              color: "#f7fdfb",
              borderRadius: [12, 12, 0, 0],
            },
            itemStyle: {
              borderRadius: [12, 12, 0, 0],
              color: "#00bd83",
            },
            barWidth: 12,
          },
        ],
      };
    },
    pieOptions() {
      return {
        tooltip: {
          show: false,
        },
        legend: {
          bottom: "5%",
          left: "center",
          itemWidth: 12,
          itemHeight: 12,
          itemGap: 24,
          selectedMode: false,
        },
        series: {
          type: "pie",
          radius: [80, 105],
          center: ["50%", "35%"],
          avoidLabelOverlap: false,
          label: {
            show: false,
            position: "center",
          },
          emphasis: {
            scale: false,
            label: {
              show: true,
              formatter: function ({ name, value }) {
                const reg = /(\d{1,3})(?=(\d{3})+$)/g;
                value = value.toString().replace(reg, "$&,"); // $& 指在完全匹配字符后追加字符，此处与$1等效
                return "{b|" + name + "}" + "\n" + "{c|" + value + "}";
              },
              rich: {
                b: {
                  fontSize: 14,
                  lineHeight: 30,
                  fontWeight: 400,
                  color: "#8998A0",
                  margin: [0, 0, 8, 0],
                },
                c: {
                  fontSize: 40,
                  color: "#040B28",
                  fontWeight: "bold",
                },
              },
            },
          },
          labelLine: {
            show: false,
          },
        },
      };
    },
    goodsCategoryOptions() {
      const color = ["#005bff", "#00bd83", "#00aaff", "#617ece", "#fac35a"];
      const data = this.commodityClassify;
      const { series } = {...this.pieOptions};

    Object.assign(series, { data })
      return Object.assign(this.pieOptions, { series, color });
    },
    userTypeOptions() {
      const color = this.color;
      const data = this.userTypeData;
      const { series } = this.pieOptions;
      Object.assign(series, { data });
      return Object.assign(this.pieOptions, { series, color });
    },
    shopTypeOptions() {
      const color = this.color;
      const data = this.shopTypeData;
      const { series } = this.pieOptions;
      Object.assign(series, { data });
      return Object.assign(this.pieOptions, { series, color });
    },
  },
  methods: {
    dataTransform(data, valueProp, nameProp) {
      let arr = [];

      if (Array.isArray(data)) {
        data.forEach((item, index) => {
          arr.push({
            value: item[valueProp],
            name: item[nameProp],
            selected: index == 0 ? true : false,
          });
        });
      }
      return arr;
    },

    rankTypeChange(val) {
      this.$ajax.get(topShop, this.shopSales).then(
        (res) => {
          if (res.status === 200) {
            this.topShopData = res.data;
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
    highlight(echarts) {
      let index = 0;
      echarts.dispatchAction({
        type: "highlight",
        seriesIndex: 0,
        dataIndex: 0,
      });
      echarts.on("mouseover", function (e) {
        if (e.dataIndex != index) {
          echarts.dispatchAction({
            type: "downplay",
            seriesIndex: 0,
            dataIndex: index,
          });
        }
      });
      echarts.on("mouseout", function (e) {
        index = e.dataIndex;
        echarts.dispatchAction({
          type: "highlight",
          seriesIndex: 0,
          dataIndex: e.dataIndex,
        });
      });
    },
    initBqdjMap() {
      const e_sales = echarts.init(this.$refs.mallDataEcharts1);
      e_sales.setOption(this.mallDataEcharts1);
    },
    initBqbhMap() {
      const e_sales = echarts.init(this.$refs.mallDataEcharts2);
      e_sales.setOption(this.mallDataEcharts2);
    },
    initjyMap() {
      const e_sales = echarts.init(this.$refs.mallDataEcharts3);
      e_sales.setOption(this.mallDataEcharts3);
    },
    getList() {
      //最近成交
      this.$ajax.get(homeGet).then(
        (res) => {
          if (res.status === 200) {
            // 成功了
            this.orderData = res.data;
          }
        },
        (err) => {
          console.log(err);
        }
      );
      // 商城店铺销售排行榜
      this.$ajax.get(topShop, this.shopSales).then(
        (res) => {
          if (res.status === 200) {
            this.topShopData = res.data;
          }
        },
        (err) => {
          console.log(err);
        }
      );
      // 待审核用户
      this.$ajax
        .get(getUserList, { pageSize: 1, state: "WAITING" })
        .then((res) => {
          if (res.status === 200) {
            this.userCertifyNumber = res.data.total;
          }
        })
        .catch((err) => {
          console.log(err.data);
        });
      // 提现待审核
      this.$ajax
        .get(withdrawing)
        .then((res) => {
          if (res.status === 200) {
            this.withdrawingData = res.data;
          }
        })
        .catch((err) => {
          console.log(err.data);
        });
      // 商品待审核
      // this.$ajax.get(commodityGet).then(
      //   (res) => {
      //     if (res.status === 200) {
      //       // 成功了
      //       this.commodityData = res.data;
      //     }
      //   },
      //   (err) => {
      //     console.log(err);
      //   }
      // );
      // 数字版权登记
      this.$ajax.get("/copyright/registration/waitAuditSts").then((res) => {
        if (res.status === 200) {
          // 成功了
          this.registrationData = res.data;
        }
      });
      // 普通版权
      this.$ajax.get(topPtbq).then(
        (res) => {
          if (res.status === 200) {
            // 成功了
            this.topPtbqData = res.data;
          }
        },
        (err) => {
          console.log(err);
        }
      );
      // 发票
      this.$ajax.get(topFpdcl).then(
        (res) => {
          if (res.status === 200) {
            // 成功了
            this.topFpdclData = res.data;
          }
        },
        (err) => {
          console.log(err);
        }
      );
      // 版权维权
      this.$ajax.get(topBqwqdcl).then(
        (res) => {
          if (res.status === 200) {
            // 成功了
            this.topBqwqdclData = res.data;
            console.log("res.data", res.data);
          }
        },
        (err) => {
          console.log(err);
        }
      );
      // 作品待审核
      this.$ajax
        .get(worksChecking)
        .then((res) => {
          this.worksCheckingData = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
      // 店铺待审核
      // this.$ajax.get(shopGet).then(
      //   (res) => {
      //     if (res.status === 200) {
      //       // 成功了
      //       this.shopGetData = res.data;
      //     }
      //   },
      //   (err) => {
      //     console.log(err);
      //   }
      // );
      // 签约待审核
      this.$ajax.get("/works/signContract/waitAuditSts").then(
        (res) => {
          if (res.status === 200) {
            // 成功了
            this.signContractData = res.data;
          }
        },
        (err) => {
          console.log(err);
        }
      );
      //投诉店铺待处理
      // this.$ajax.get(feedbackGet).then(
      //   (res) => {
      //     if (res.status === 200) {
      //       // 成功了
      //       this.feedback = res.data;
      //     }
      //   },
      //   (err) => {
      //     console.log(err);
      //   }
      // );
      // 上架作品数
      this.$ajax.get("/works/worksUpload/sale-works").then(
        (res) => {
          if (res.status === 200) {
            // 成功了
            this.saleWorks = res.data;
          }
        },
        (err) => {
          console.log(err);
        }
      );
      //投诉商品待处理
      // this.$ajax.get(complainGoodsGet).then(
      //   (res) => {
      //     if (res.status === 200) {
      //       // 成功了
      //       this.complainGoods = res.data;
      //     }
      //   },
      //   (err) => {
      //     console.log(err);
      //   }
      // );
      // 上架资源数
      this.$ajax.get("/works/worksUpload/sale-resources").then(
        (res) => {
          if (res.status === 200) {
            // 成功了
            this.saleResources = res.data;
          }
        },
        (err) => {
          console.log(err);
        }
      );
      // 已签约
      this.$ajax.get("/works/signContract/passSts").then(
        (res) => {
          if (res.status === 200) {
            // 成功了
            this.passSts = res.data;
          }
        },
        (err) => {
          console.log(err);
        }
      );
      //意见反馈待处理
      // this.$ajax.get(complainStoreGet).then(
      //   (res) => {
      //     if (res.status === 200) {
      //       // 成功了
      //       this.complainStore = res.data;
      //     }
      //   },
      //   (err) => {
      //     console.log(err);
      //   }
      // );
      // 商城销售数据
      // this.$ajax.get(shoppingGet).then(
      //   (res) => {
      //     if (res.status === 200) {
      //       // 成功了
      //       this.mallSalesOptionsData = res.data;
      //     }
      //     if (this.$refs.mallDataEcharts) {
      //       const e_sales = echarts.init(this.$refs.mallDataEcharts);
      //       e_sales.setOption(this.mallSalesOptions);
      //     }
      //   },
      //   (err) => {
      //     console.log(err);
      //   }
      // );
      // 版权登记图表
      this.$ajax.get(bqdjMap).then(
        (res) => {
          if (res.status === 200) {
            // 成功了
            this.bqdjMapData = res.data;
          }
          if (this.$refs.mallDataEcharts1) {
            this.initBqdjMap();
          }
        },
        (err) => {
          console.log(err);
        }
      );
      // 交易数据图表
      this.$ajax.get("/works/worksUpload/saleMoneySts").then(
        (res) => {
          if (res.status === 200) {
            // 成功了
            this.jyMapData = res.data;
          }
          if (this.$refs.mallDataEcharts3) {
            this.initjyMap();
          }
        },
        (err) => {
          console.log(err);
        }
      );
      // 版权登记图表
      this.$ajax.get(bqbhMap).then(
        (res) => {
          if (res.status === 200) {
            // 成功了
            this.bqbhMapData = res.data;
          }
          if (this.$refs.mallDataEcharts2) {
            this.initBqbhMap();
          }
        },
        (err) => {
          console.log(err);
        }
      );
      //商品分类比例 commodityClassifyGet
      this.$ajax.get("/works/worksUpload/sale-works-type").then(
        (res) => {
          if (res.status === 200) {
            // 成功了
            this.commodityClassify = this.dataTransform(res.data, "cnt", "type");
          }
          if (this.$refs.goodsCategoryEchart) {
            const e_goods = echarts.init(this.$refs.goodsCategoryEchart);
            e_goods.setOption(this.goodsCategoryOptions);
            this.highlight(e_goods);
          }
        },
        (err) => {
          console.log(err);
        }
      );
      //登记来源
      this.$ajax.get(registerSourceGet).then(
        (res) => {
          if (res.status === 200) {
            // 成功了
            this.userTypeData = this.dataTransform(res.data, "cnt", "type");
          }
          if (this.$refs.userTypeEchart) {
            const e_user = echarts.init(this.$refs.userTypeEchart);
            e_user.setOption(this.userTypeOptions);
            this.highlight(e_user);
          }
        },
        (err) => {
          console.log(err);
        }
      );
      // 版权登记作品分类
      this.$ajax.get(workCategoryGet).then(
        (res) => {
          if (res.status === 200) {
            // 成功了
            this.shopTypeData = this.dataTransform(res.data, "cnt", "type");
          }
          if (this.$refs.shopTypeEchart) {
            const e_shop = echarts.init(this.$refs.shopTypeEchart);
            e_shop.setOption(this.shopTypeOptions);
            this.highlight(e_shop);
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
    handleResize() {
      // if (this.$refs.mallDataEcharts) {
      //   this.$refs.mallDataEcharts.resize();
      // }
      if (this.$refs.mallDataEcharts1) {
        echarts.getInstanceByDom(this.$refs.mallDataEcharts1).resize();
      }
      if (this.$refs.mallDataEcharts2) {
        echarts.getInstanceByDom(this.$refs.mallDataEcharts2).resize();
      }
      if (this.$refs.mallDataEcharts3) {
        echarts.getInstanceByDom(this.$refs.mallDataEcharts3).resize();
      }
      if (this.$refs.goodsCategoryEchart) {
        echarts.getInstanceByDom(this.$refs.goodsCategoryEchart).resize();
      }
      if (this.$refs.userTypeEchart) {
        echarts.getInstanceByDom(this.$refs.userTypeEchart).resize();
      }
      if (this.$refs.shopTypeEchart) {
        echarts.getInstanceByDom(this.$refs.shopTypeEchart).resize();
      }

    },
  },
  created() {
    if (this.$store.state.onePageHidden) {
      this.getList();
      // this.$ajax.get(orderGet).then(res => {
      //   console.log(res);
      // });
    }
  },
  mounted() {
    // 添加防抖
    this.handleResize = debounce(this.handleResize, 200);
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
    /**
     * 在页面注销前释放所有echarts实例
     */
    // echarts.dispose(this.$refs.mallDataEcharts);
    echarts.dispose(this.$refs.mallDataEcharts1);
    echarts.dispose(this.$refs.mallDataEcharts2);
    echarts.dispose(this.$refs.mallDataEcharts3);
    echarts.dispose(this.$refs.goodsCategoryEchart);
    echarts.dispose(this.$refs.userTypeEchart);
    echarts.dispose(this.$refs.shopTypeEchart);
  },
};
</script>

<style lang="scss">
.admin-home {
  min-width: 1300px;
  ul,
  li {
    padding: 0;
    margin: 0;
    list-style: none;
  }
  .flex-row {
    width: 100%;
    margin-top: 16px;
    display: flex;
    .flex-col {
      &:not(:last-of-type) {
        margin-right: 21px;
        margin-bottom: 0px !important;
      }
    }
  }
  .el-table {
    border: 1px solid #ebeef5;
    border-bottom: none;
  }
  .wait-for-handle-addon {
    width: 100%;
    height: 126px;
    margin-top: 16px;
    display: flex;
    .handle-addon-item {
      background-color: white;
      display: flex;
      width: 530px;
      max-width: 530px;
      margin-right: 21px;
      &:last-of-type {
        margin-right: 0;
      }
    }
    .left-icon {
      margin: 18px;
      height: 90px;
      width: 90px;
      background-color: #005bff;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        height: 37px;
        width: 37px;
      }
    }
    .right-body {
      padding: 31px 40px 25px 1px;
      flex: 1;
      h4 {
        height: 22px;
        line-height: 22px;
        font-size: 16px;
        font-weight: 500;
        color: #b2b5bc;
      }
      div {
        margin-top: 6px;
        height: 42px;
        line-height: 42px;
        font-size: 31px;
        font-weight: 500;
        color: #242f45;
        width: 100%;

        span:last-of-type {
          float: right;
          font-size: 20px;
          font-weight: 400;
          word-spacing: 10px;
          color: #99bdff;
        }
      }
    }
  }
  .page-title.wait-for-handle {
    width: 1632px;
    .subtitle {
      font-size: 12px;
      color: #8998a0;
      height: 20px;
      display: flex;
      align-items: center;
      margin-left: 8px;
      font-weight: 400;
      .el-icon-circle {
        font-size: 18px;
        margin-right: 2px;
      }
    }
    .body {
      display: flex;
    }
  }
  .page-title.mall-data {
    max-width: 530px;
    width: 530px;
    margin-bottom: 0px;
    .mall-data-subtitle {
      display: flex;
      align-items: center;
      flex: 1;
      .mall-sales-legend {
        flex: 1;
        text-align: center;
        span {
          font-size: 12px;
          font-weight: 400;
          color: #8998a0;
          position: relative;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          &::before {
            content: "";
            position: absolute;
            height: 12px;
            width: 12px;
            left: -15px;
            top: 0;
            bottom: 0;
            margin: auto 0;
            border-radius: 2px;
          }
          &.wyqz {
            margin-left: 37px;
            &::before {
              background-color: #f68679 !important;
            }
          }
          &.qwjc {
            margin-left: 37px;
            &::before {
              background-color: #2ac399 !important;
            }
          }
          &.bqwq {
            margin-left: 37px;
            &::before {
              background-color: #eeba7d !important;
            }
          }
          &.spqz {
            margin-left: 37px;
            &::before {
              background-color: #2ab4fc !important;
            }
          }
          &:first-of-type {
            &::before {
              background-color: #005bff;
            }
            margin-left: 37px;
          }
          &:last-of-type {
            &::before {
              background-color: #00bd83;
            }
            margin-left: 27px;
          }
        }
      }
    }
    .el-date-editor {
      margin-left: auto;
      position: relative;
      width: 192px;
      height: 32px;
      line-height: 32px;

      .el-icon-date {
        position: absolute;
        right: 8px;
        margin: 0;
        width: 16px;
        font-size: 16px;
        line-height: 30px;
      }
    }
  }
  .page-title.shop-sales-data {
    max-width: 658px;
    width: 658px;

    .shop-sales-data__body {
      // height: 340px;
      .selector {
        display: inline-block;
        font-size: 12px;
        font-weight: 400;
        color: #161c26;

        &:first-child {
          margin-right: 40px;
        }

        margin-bottom: 18px;
      }
    }
  }
  .page-title.goods-category-propor {
    width: 530px;
    max-width: 530px;
  }
  .page-title.recent {
    width: 806px;
    max-width: 806px;

    .recent__body {
      min-height: 352px;

      .table-col {
        display: flex;
        white-space: nowrap;
        color: #040b28;

        i {
          height: 20px;
          width: 20px;
          line-height: 20px;
          font-size: 14px;
          text-align: center;
          border-radius: 50%;
          color: white;
          margin-right: 6px;
        }
      }

      .buyer-label {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        width: 120px;
        min-width: 120px;
        i {
          background-color: #00bd83;
        }
      }

      .text-label {
        display: inline-block;
        color: #8998a0;
        &:first-of-type {
          margin-right: 12px;
          margin-left: 12px;
        }
      }

      .seller-label {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-right: 12px;
        width: 120px;
        min-width: 120px;
        i {
          background-color: #005bff;
        }
      }
    }
  }
  .page-title.user-type {
    width: 530px;
    max-width: 530px;
  }
  .page-title.shop-type {
    width: 530px;
    max-width: 530px;
    margin-bottom: 0px;
  }
  #echarts {
    height: 340px;
    width: 100%;
  }
}
.mall-data1 {
  width: 806px !important;
  max-width: 806px !important;
}
</style>
